<template>

    <div class='col-12 md:col-6 lg:col-3'>
        <div class='surface-card shadow-0 p-3 border-round' style='border:1px solid #dfe7ef'>
            <div class='flex justify-content-between mb-3'>
                <span class='block font-medium mb-3 text-xl'>Aktif Personel</span>
                <div class='flex align-items-center justify-content-center border-round' style='width:2.5rem;height:2.5rem'>
                    <i>
                        <img src='/layout/images/icon/kullanicilar.svg' height='54' class='mt-2 mr-2' />
                    </i>
                </div>
            </div>
            <div class="mt-2">
                <div class='text-900 font-bold text-xl'>
                    <span>Toplam</span> {{ report.totalPersonal }}<span class='font-light ml-1'>Kişi</span>
                </div>
            </div>
        </div>
    </div>

    <div class='col-12 md:col-6 lg:col-3'>
        <div class='surface-card shadow-0 p-3 border-round' style='border:1px solid #dfe7ef'>
            <div class='flex justify-content-between mb-3'>
                <span class='block font-medium mb-3 text-xl'>Maaş Ödeme</span>
                <div class='flex align-items-center justify-content-center border-round' style='width:2.5rem;height:2.5rem'>
                    <i>
                        <img src='/layout/images/icon/resmi_odeme.svg' height='54' class='mt-2 mr-2' />
                    </i>
                </div>
            </div>
            <div class="mt-2">
                <div class='text-900 font-bold text-xl'>
                    {{ formatPrice(report.totalOfficialPrice)}}<span class='font-light ml-1'>&#8378;</span>
                </div>
            </div>
        </div>
    </div>

    <div class='col-12 md:col-6 lg:col-3'>
        <div class='surface-card shadow-0 p-3 border-round' style='border:1px solid #dfe7ef'>
            <div class='flex justify-content-between mb-3'>
                <span class='block font-medium mb-3 text-xl'>Diğer Ödeme</span>
                <div class='flex align-items-center justify-content-center border-round' style='width:2.5rem;height:2.5rem'>
                    <i>
                        <img src='/layout/images/icon/diger_odeme.svg' height='54' class='mt-2 mr-2' />
                    </i>
                </div>
            </div>
            <div class="mt-2">
                <div class='text-900 font-bold text-xl'>
                    {{ formatPrice(report.totalUnOfficialPrice)}}<span class='font-light ml-1'>&#8378;</span>
                </div>
            </div>
        </div>
    </div>
    
    <div class='col-12 md:col-6 lg:col-3'>
        <div class='surface-card shadow-0 p-3 border-round' style='border:1px solid #dfe7ef'>
            <div class='flex justify-content-between mb-3'>
                <span class='block font-medium mb-3 text-xl'>Toplam Ödeme</span>
                <div class='flex align-items-center justify-content-center border-round' style='width:2.5rem;height:2.5rem'>
                    <i>
                        <img src='/layout/images/icon/kasa.svg' height='54' class='mt-2 mr-2' />
                    </i>
                </div>
            </div>
            <div class="mt-2">
                <div class='text-900 font-bold text-xl'>
                    {{ formatPrice(report.totalPrice)}}<span class='font-light ml-1'>&#8378;</span>
                </div>
            </div>
        </div>
    </div>



</template>

<script>
export default {
    name: 'EmployeeListReport',
    props: {
        report: {},
    },
    methods : {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
    }
};
</script>
